import { Group } from '../../groups/api/group.model';

function isComposableDevice(group?: Group) {
  return !!group?.composableDevice;
}

export default isComposableDevice;
